// src/app/app.footer.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common'; // Needed for CommonModule features like *ngIf
import { catchError, throwError } from 'rxjs'; // For error handling
import { TranslateService } from '../../services/translate.service';
import { DialogService } from 'primeng/dynamicdialog';
import { DialogModule } from 'primeng/dialog';
import { DiagnosticComponent } from '../../pages/system/diagnostic/diagnostic.component';

@Component({
	standalone: true,
	selector: 'app-footer',
	templateUrl: './app.footer.html',
	styleUrls: ['./app.footer.scss'],
	imports: [CommonModule],
	providers: [DialogService]
})
export class AppFooter {
	isLoading: boolean = false;
	successMessage: string | null = null;
	errorMessage: string | null = null;
	bigMessage: string | null = null;
	private diagnosticClickCount = 0;
	private readonly requiredDiagnosticClicks = 5;

	constructor(public translateServ: TranslateService, private dialogService: DialogService) { }

	sendPostRequest(): void {
		this.diagnosticClickCount++;

		if (this.diagnosticClickCount < this.requiredDiagnosticClicks) {
			return;
		}

		this.diagnosticClickCount = 0;
		this.openDiagnosticDialog();
	}

	private openDiagnosticDialog(): void {
		// Open a PrimeNG dynamic dialog that hosts the DiagnosticComponent
		const ref = this.dialogService.open(DiagnosticComponent, {
			header: this.translateServ.dictionary?.['DIAGNOSTIC_TITLE'] || 'Diagnostics',
			width: '60vw',
			height: '70vh',
			data: {
				userName: null,
				environment: 'development'
			},
			modal: true,
			dismissableMask: true,
			draggable: true,        // Allow moving the dialog
			closable: true,        // Show close button in header
			imports: [CommonModule, DialogModule, DiagnosticComponent]
		} as any);

		// Optional: react when dialog closes
		try {
			(ref as any).onClose?.subscribe?.(() => {
				// noop for now
			});
		} catch (e) {
			// ignore
		}
	}

	showBigMessage(message: string, duration: number = 3000): void {
		this.bigMessage = message;
		setTimeout(() => {
			this.bigMessage = null;
		}, duration);
	}
}